/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MTReminderDescription
 */
export interface MTReminderDescription {
    /**
     * 
     * @type {string}
     * @memberof MTReminderDescription
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MTReminderDescription
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof MTReminderDescription
     */
    description: string;
}

/**
 * Check if a given object implements the MTReminderDescription interface.
 */
export function instanceOfMTReminderDescription(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function MTReminderDescriptionFromJSON(json: any): MTReminderDescription {
    return MTReminderDescriptionFromJSONTyped(json, false);
}

export function MTReminderDescriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MTReminderDescription {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'title': json['title'],
        'description': json['description'],
    };
}

export function MTReminderDescriptionToJSON(value?: MTReminderDescription | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'title': value.title,
        'description': value.description,
    };
}

